const { default: axiosIns } = require('@/libs/axios')

const PropertiesService = {
  // GET - PropertyApiController
  async getProperties(accountId) {
    return axiosIns.get(`/properties?accountId=${accountId}`).then(response => response.data)
  },
  async getProperty(propertyId, accountId) {
    return axiosIns.get(`/properties/${propertyId}?accountId=${accountId}`).then(response => response.data)
  },
  async exportCsv(dateRange, propertyIds, monetizationContentIds, accountId) {
    return axiosIns
      .get(`/properties/export/csv?accountId=${accountId}&daterange=${dateRange}&propertyIds=${propertyIds.toString()}&monetizationContentIds=${monetizationContentIds.toString()}`, { responseType: 'blob' })
      .then(response => response.data)
  },
  async exportExcel(dateRange, propertyIds, monetizationContentIds, accountId) {
    return axiosIns
      .get(`/properties/export/excel?accountId=${accountId}&daterange=${dateRange}&propertyIds=${propertyIds.toString()}&monetizationContentIds=${monetizationContentIds.toString()}`, { responseType: 'blob' })
      .then(response => response.data)
  },
  // POST - PropertyApiController
  async createProperty(model, accountId) {
    return axiosIns.post(`/properties?accountId=${accountId}`, model).then(response => response.data)
  },
}

export default PropertiesService
